import TreeItem from './tree-item.element.js';

export default TreeItem;

TreeItem.define('wje-tree-item', TreeItem);
